// SEO fields used by GameserverDetail:
//   seoSummary – meta description text; "From €<price><priceUnit>: " is prepended
//                automatically, so keep it ≤ 135 characters
//   seoName    – optional product name when "<name> Server" reads badly
export const GAMESERVERS = [
  // ── Minecraft family ───────────────────────────────────────────────
  {
    slug: 'minecraft',
    name: 'Minecraft',
    tags: ['Survival', 'Open-World'],
    image: '/images/games/minecraft.svg',
    price: '1.50',
    priceUnit: '/GB RAM/month',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=645',
    tagline: 'Unlimited possibilities — your world, your rules.',
    description:
      'From €1.50 per GB RAM: run your own Minecraft server with unlimited slots, OneClick mod & plugin installation, and full FTP access. Whether for a small group of friends or a large public community — scale on demand.',
    seoSummary:
      'Your own Minecraft server with unlimited slots, one-click mods & plugins, full FTP access and DDoS protection. No contract.',
    highlights: [
      'OneClick Mod & Plugin Installation',
      'Bukkit / Spigot / Paper support',
      'Unlimited Slots',
      'Worldmanager included',
    ],
    featured: true,
  },
  {
    slug: 'minecraft-bungeecord',
    name: 'Minecraft – BungeeCord',
    tags: ['Survival', 'Network'],
    image: '/images/games/minecraft.svg',
    price: '4.95',
    priceUnit: '/month',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=397',
    tagline: 'Connect multiple Minecraft servers into one network.',
    description:
      'Easily link your existing Minecraft servers with BungeeCord and let players switch between game modes and servers without disconnecting.',
    seoSummary:
      'Link your Minecraft servers into one BungeeCord network – players switch servers without disconnecting. Full FTP, no contract.',
    highlights: [
      'Multi-server network',
      'Seamless player switching',
      'Compatible with all Spigot plugins',
      'Full FTP & console access',
    ],
  },
  {
    slug: 'minecraft-bedrock',
    name: 'Minecraft – Bedrock',
    tags: ['Survival', 'Crossplay'],
    image: '/images/games/minecraft.svg',
    price: '3.75',
    priceUnit: '/month',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=399',
    tagline: 'Cross-platform Minecraft for mobile, console & PC.',
    description:
      'Minecraft Bedrock Edition lets players on different platforms join the same server – mobile, Xbox, PlayStation, and Windows 10/11 all in one place.',
    seoSummary:
      'Minecraft Bedrock server with crossplay for mobile, Xbox, PlayStation and Windows players. DDoS protection, instant setup.',
    highlights: [
      'Cross-platform (mobile, console, PC)',
      'Full FTP & console access',
      'Instant setup',
      'DDoS protection included',
    ],
  },
  {
    slug: 'minecraft-pocketmine',
    name: 'Minecraft – Pocketmine',
    tags: ['Survival', 'Mobile'],
    image: '/images/games/minecraft.svg',
    price: '3.75',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=645',
    tagline: 'Minecraft Pocket Edition server with plugin support.',
    description:
      'PocketMine-MP is the server software for the Minecraft mobile version. Host your own pocket edition server with plugin support and full management access.',
    seoSummary:
      'PocketMine-MP server for Minecraft mobile with plugin support and full management access. DDoS protection, no contract.',
    highlights: [
      'PocketMine-MP server software',
      'Plugin support',
      'Mobile-friendly',
      'Full FTP & console access',
    ],
  },

  // ── Shooter ───────────────────────────────────────────────────────
  {
    slug: 'csgo',
    name: 'CS:GO / CS2',
    tags: ['Shooter', 'First-Person'],
    image: '/images/games/csgo.svg',
    price: '4.80',
    priceUnit: '/month',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=386',
    tagline: 'Competitive shooter at peak performance. Always online.',
    description:
      'Run a low-latency CS:GO or CS2 server for your community. Steam Workshop maps, custom plugins via SourceMod, and DDoS protection keep your match clean and online.',
    seoSummary:
      'Low-latency CS:GO / CS2 server in Frankfurt with Workshop maps, SourceMod plugins and DDoS protection. Instant setup, no contract.',
    highlights: [
      'SourceMod & MetaMod support',
      'Steam Workshop map support',
      'Custom CVAR settings',
      'Competitive & casual modes',
    ],
  },
  {
    slug: 'css',
    name: 'Counter-Strike: Source',
    tags: ['Shooter', 'First-Person'],
    image: '/images/games/css.svg',
    price: '4.80',
    priceUnit: '/month',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=410',
    tagline: 'The classic Source engine shooter — your server, your rules.',
    description:
      'Start your own CS:Source server within minutes. SourceMod and MetaMod support, custom maps via Steam Workshop, and DDoS protection included.',
    seoSummary:
      'Counter-Strike: Source server with SourceMod & MetaMod, Workshop maps and DDoS protection – online in minutes, no contract.',
    highlights: [
      'SourceMod & MetaMod support',
      'Steam Workshop map support',
      'Custom CVAR & map config',
      'DDoS protection included',
    ],
  },

  // ── Survival / Open-World ─────────────────────────────────────────
  {
    slug: 'rust',
    name: 'Rust',
    tags: ['Survival', 'Open-World'],
    image: '/images/games/rust.svg',
    price: '10.00',
    priceUnit: '/month',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=361',
    tagline: 'Your world is hostile. Be the last one standing.',
    description:
      'High-performance Rust server hosting on AMD Ryzen hardware. No slot limits, full Oxide mod support, and instant setup. Claim your island and build your empire.',
    seoSummary:
      'Rust server on AMD Ryzen hardware with no slot limit, full Oxide mod support, DDoS protection and instant setup.',
    highlights: [
      'AMD Ryzen 3700x CPUs',
      'Oxide Mod support',
      'Unlimited Slots',
      'Automatic game updates',
    ],
  },
  {
    slug: 'valheim',
    name: 'Valheim',
    tags: ['Survival', 'Open-World'],
    image: '/images/games/valheim.svg',
    price: '5.99',
    priceUnit: '/month',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=488',
    tagline: 'Explore, build, and conquer Norse mythology with friends.',
    description:
      'Your own Valheim server: explore the 10th world together, build your Viking village, and defeat the biome bosses. Full FTP access, DDoS protection, and instant setup.',
    seoSummary:
      'Your own Valheim server for you and your friends – full FTP access, DDoS protection and instant setup in Frankfurt.',
    highlights: [
      'Dedicated hardware',
      'World backups included',
      'Unlimited players',
      'Easy world upload via FTP',
    ],
  },
  {
    slug: 'ark',
    name: 'ARK: Survival Evolved',
    tags: ['Survival', 'Open-World'],
    image: '/images/games/ark.svg',
    price: '10.00',
    priceUnit: '/month',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=373',
    tagline: 'Tame dinosaurs, build your tribe, and rule the island.',
    description:
      'Your own ARK server with full Steam Workshop mod support, custom settings, and unlimited players. All official and unofficial maps supported.',
    seoSummary:
      'ARK: Survival Evolved server with Steam Workshop mods, all official and unofficial maps, custom settings and DDoS protection.',
    highlights: [
      'All official maps supported',
      'Full Steam Workshop mod support',
      'Custom INI config access',
      'Automatic updates',
    ],
  },
  {
    slug: 'terraria',
    name: 'Terraria',
    tags: ['Survival', 'Open-World'],
    image: '/images/games/terraria.svg',
    price: '2.00',
    priceUnit: '/month',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=404',
    tagline: '2D adventure packed with bosses, loot, and endless building.',
    description:
      'Dig, build, fight — your own Terraria server for you and your friends. TShock mod support, custom world upload, and always-on hosting.',
    seoSummary:
      'Your own Terraria server with TShock support, custom world upload and always-on hosting. DDoS protection, no contract.',
    highlights: [
      'TShock server support',
      'Custom world upload',
      'Unlimited players',
      'Plugin support',
    ],
  },
  {
    slug: '7-days-to-die',
    name: '7 Days to Die',
    tags: ['Survival', 'Open-World'],
    image: '/images/games/7dtd.svg',
    price: '4.80',
    priceUnit: '/month',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=409',
    tagline: 'Post-apocalyptic survival — hold off the horde every 7th night.',
    description:
      'Run your own 7 Days to Die server with full config access, custom maps, and mod support. Defend your base together and survive the weekly zombie hordes.',
    seoSummary:
      '7 Days to Die server with full config access, custom maps and mod support – survive the hordes together. No contract.',
    highlights: [
      'Full serverconfig.xml access',
      'Mod support',
      'Automatic game updates',
      'Custom world & seed settings',
    ],
  },
  {
    slug: 'the-forest',
    name: 'The Forest',
    tags: ['Survival', 'Open-World'],
    image: '/images/games/theforest.svg',
    price: '4.80',
    priceUnit: '/month',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=490',
    tagline: 'Build your shelter, avoid the cannibals, explore the dark.',
    description:
      'Crash-land on a mysterious island and survive together. Host your own The Forest co-op server with full save management and dedicated hardware.',
    seoSummary:
      'The Forest co-op server with full save management on dedicated hardware. DDoS protection, instant setup, no contract.',
    highlights: [
      'Dedicated hardware',
      'Save & backup system',
      'Instant setup',
      'Co-op multiplayer ready',
    ],
  },
  {
    slug: 'eco',
    name: 'Eco',
    tags: ['Survival', 'Open-World'],
    image: '/images/games/eco.svg',
    price: '4.80',
    priceUnit: '/month',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=479',
    tagline: 'Build a civilization — before the meteor hits.',
    description:
      'Eco requires serious performance. Host on powerful hardware in Frankfurt for minimal latency and smooth simulation. Persistent worlds, full mod support.',
    seoSummary:
      'Eco server on powerful hardware in Frankfurt – persistent worlds, smooth simulation and full mod support. No contract.',
    highlights: [
      'Persistent world',
      'Mod & plugin support',
      'Custom meteor timer',
      'Full FTP access',
    ],
  },
  {
    slug: 'factorio',
    name: 'Factorio',
    tags: ['Survival', 'Open-World'],
    image: '/images/games/factorio.svg',
    price: '4.80',
    priceUnit: '/month',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=450',
    tagline: 'Automate everything. Build the ultimate factory.',
    description:
      'Host your own Factorio multiplayer server. Low latency, persistent worlds, and full mod portal support. The headless server runs 24/7.',
    seoSummary:
      'Factorio multiplayer server running 24/7 headless with mod portal support, persistent worlds and low latency. No contract.',
    highlights: [
      'Mod portal integration',
      'Persistent world saves',
      'Headless dedicated server',
      'Easy save management',
    ],
  },

  // ── Sandbox ───────────────────────────────────────────────────────
  {
    slug: 'garrys-mod',
    name: "Garry's Mod",
    tags: ['Sandbox'],
    image: '/images/games/gmod.svg',
    price: '4.80',
    priceUnit: '/month',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=370',
    tagline: 'The ultimate sandbox — build, script, and break anything.',
    description:
      "Your own Garry's Mod server with full Steam Workshop addon support. Run custom gamemodes like DarkRP, TTT, Prophunt, or Sandbox.",
    seoSummary:
      "Garry's Mod server with Workshop addons for DarkRP, TTT, Prophunt or Sandbox. DDoS protection, instant setup, no contract.",
    highlights: [
      'Steam Workshop addon support',
      'Custom gamemodes (DarkRP, TTT, …)',
      'MySQL database included',
      'Full console & FTP access',
    ],
  },

  // ── GTA Multiplayer ───────────────────────────────────────────────
  {
    slug: 'altv',
    name: 'alt:V Multiplayer',
    tags: ['GTA MP', 'Open-World'],
    image: '/images/games/altv.svg',
    price: '2.00',
    priceUnit: '/month',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=476',
    tagline: 'Your own GTA multiplayer server. Full resource support.',
    description:
      'Host your own alt:V roleplay or freeroam server with full resource support and low-latency Frankfurt hosting. Easy resource upload via FTP.',
    seoSummary:
      'alt:V server for GTA V roleplay or freeroam with full resource support, FTP upload and low latency in Frankfurt.',
    highlights: [
      'Full resource & script support',
      'Easy resource upload via FTP',
      'Automatic alt:V updates',
      'Custom vehicle & map support',
    ],
  },
  {
    slug: 'samp',
    name: 'GTA SA:MP',
    tags: ['GTA MP', 'Open-World'],
    image: '/images/games/samp.svg',
    price: '4.80',
    priceUnit: '/month',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=431',
    tagline: 'GTA San Andreas Multiplayer — the classic open-world server.',
    description:
      'Host your own SA:MP server and bring GTA San Andreas to life with multiplayer. Full script support, custom gamemodes, and DDoS protection included.',
    seoSummary:
      'SA:MP server for GTA San Andreas multiplayer with full script support, custom gamemodes and DDoS protection.',
    highlights: [
      'Full script/gamemode support',
      'Custom filterscripts',
      'DDoS protection',
      'Instant setup',
    ],
  },
  {
    slug: 'mta',
    name: 'GTA MTA',
    tags: ['GTA MP', 'Open-World'],
    image: '/images/games/mta.svg',
    price: '4.80',
    priceUnit: '/month',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=430',
    tagline: 'Multi Theft Auto — GTA Vice City & San Andreas multiplayer.',
    description:
      'Multi Theft Auto lets you play GTA Vice City and San Andreas in multiplayer mode. Host your own MTA server with full Lua script support and DDoS protection.',
    seoSummary:
      'MTA server for GTA San Andreas multiplayer with full Lua scripting, DDoS protection and instant setup. No contract.',
    highlights: [
      'Lua script support',
      'Custom resources',
      'DDoS protection',
      'Instant setup',
    ],
  },

  // ── Managed / Windows ─────────────────────────────────────────────
  {
    slug: 'managed-windows',
    name: 'Managed Gameserver',
    tags: ['Windows', 'Managed'],
    image: '/images/games/managedgamewin.svg',
    price: '10.00',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=confproduct&i=0',
    tagline: 'Your own managed Windows game server — any game, any setup.',
    description:
      'A fully managed Windows game server for games not covered by our standard lineup. We set up and manage the server for you — just tell us your game.',
    seoName: 'Managed Windows Game Server',
    seoSummary:
      'Managed Windows game server for any game outside our lineup – we set it up and manage it for you. Remote desktop included.',
    highlights: [
      'Windows Server environment',
      'Any game installable',
      'Fully managed setup',
      'Remote desktop access',
    ],
  },
  {
    slug: 'farming-simulator',
    name: 'Farming Simulator 22/25',
    tags: ['Windows', 'LS22/LS25', 'Crossplay'],
    image: '/images/games/ls22.jpg',
    price: '10.00',
    priceUnit: '/month',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=522',
    tagline: 'Manage your farm, grow your business, play with friends.',
    description:
      'Host your own Farming Simulator 22 or 25 server with Windows support, Crossplay, and full mod support. Full FTP access and dedicated hardware in Frankfurt.',
    seoSummary:
      'Farming Simulator 22/25 server on Windows with crossplay, full mod support and FTP access in Frankfurt. No contract.',
    highlights: [
      'LS22 & LS25 support',
      'Windows server',
      'Crossplay enabled',
      'Full mod support',
    ],
  },

  // ── Special ───────────────────────────────────────────────────────
  {
    slug: 'hytale',
    name: 'Hytale',
    tags: ['Survival', 'Open-World'],
    image: '/images/games/hytale.png',
    price: '5.99',
    priceUnit: '/month',
    orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=643',
    tagline: 'Next-generation sandbox RPG. Unlimited adventures.',
    description:
      'Get ready for Hytale — the next-generation sandbox RPG. 4 GB RAM included, ultra-fast NVMe storage, and gaming-grade CPUs ensure smooth performance from day one.',
    seoSummary:
      'Hytale server with 4 GB RAM, ultra-fast NVMe storage and gaming-grade CPUs. Instant activation, DDoS protection.',
    highlights: [
      '4 GB RAM included',
      'Ultra-fast NVMe SSD storage',
      'Gaming-grade CPU',
      'Instant activation after payment',
    ],
  },
];

export function getGameBySlug(slug) {
  return GAMESERVERS.find((g) => g.slug === slug) || null;
}
